<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="shadows-in-the-cave">
<h1>Shadows in the Cave</h1>
<p>Thou speakest yet to me!</p>
<p style="text-indent: 00em !important;">Oh, Holy Fire in the Cave,</p>
<p style="text-indent: 00em !important;">Thy tongues of gold and blue consume thy substance,</p>
<p style="text-indent: 00em !important;">As I, poor creature of an unknowing destiny,</p>
<p style="text-indent: 00em !important;">Consume the life I barely knew.</p>
<p style="text-indent: 00em !important;">Pretence and folly marks me sorely so</p>
<p style="text-indent: 00em !important;">Whilst shadows cast upon the Cave’s rough hue,</p>
<p style="text-indent: 00em !important;">Holds me transfixed so like the Pole Star, true.</p>
<p style="text-indent: 00em !important;">Tongues of flame in dreamlike state</p>
<p style="text-indent: 00em !important;">That jump and dance and shadows make</p>
<p style="text-indent: 00em !important;">Enacted as a puppet tugged would go!</p>
<p style="text-indent: 00em !important;">But is thy shadow Chance or Fate,</p>
<p style="text-indent: 00em !important;">Or do I for my pity’s sake,</p>
<p style="text-indent: 00em !important;">Pretend to make a show?</p>
<p style="text-indent: 00em !important;">Dross!</p>
<p style="text-indent: 00em !important;">Am I so cheaply sold or bought,</p>
<p style="text-indent: 00em !important;">Or destiny’s plaything, overwrought? CED.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?3a560fd6